<span>{{ formattedCouponCodeValue$ | async }}</span>